<h1 appSlideup [slideUpDelay]="100">
  <!-- <span>About Us</span> <app-logo [size]="180"></app-logo> -->
  <app-logo [size]="160"></app-logo>
</h1>

<h2 appSlideup [slideUpDelay]="150">Fashion for real life, made to feel effortless.</h2>

<article>

  <!-- <img src="/images/about/1.webp" width="300" height="450" appSlideRight [slideRightDelay]="100" /> -->
  <h3 appSlideup [slideUpDelay]="200">Our Story</h3>
  <p appSlideup [slideUpDelay]="250">Founded in 2024, {{appname}} is built by a young entrepreneurial team with 7
    years of experience in the apparel
    industry. We started this brand with a simple belief: fashion should feel stylish, effortless, and close to real
    life.</p>
  <p appSlideup [slideUpDelay]="300">Our team brings together experience in clothing selection, styling, operations, and
    customer experience, working
    every day to create pieces that help women feel confident, natural, and beautifully themselves.
  </p>
  <h3 appSlideup [slideUpDelay]="350">Our Design Philosophy</h3>
  <p appSlideup [slideUpDelay]="400">We design with real life in mind — easy movement, comfortable fits, modern
    silhouettes, and thoughtful details.</p>
  <p appSlideup [slideUpDelay]="450">Every piece is selected to feel wearable, versatile, and expressive, so women can
    dress with confidence from
    everyday moments to special plans.</p>

  <p appSlideup [slideUpDelay]="500">
    Thank you for choosing <b>{{appname}}</b> — where fashion meets soul.
  </p>
</article>